'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this));

    _this.state = { isHovering: false };
    return _this;
  }

  _createClass(_class, [{
    key: 'render',
    value: function render() {
      var color = this.state.isHovering && this.props.hoverColor ? this.props.hoverColor : this.props.color;
      return _react2.default.createElement(
        'span',
        { onMouseOut: this.onMouseOut.bind(this), onMouseOver: this.onMouseOver.bind(this) },
        _react2.default.createElement(
          'svg',
          { viewBox: '0 0 27 17', width: '100%', height: '100%' },
          _react2.default.createElement(
            'g',
            { fill: 'none', fillRule: 'evenodd' },
            _react2.default.createElement('path', { d: 'M.75 3.613a2.49 2.49 0 1 1 2.491 2.49 2.492 2.492 0 0 1-2.49-2.49zm9.726 10.147a2.49 2.49 0 1 1 2.486 2.49 2.489 2.489 0 0 1-2.49-2.49z', stroke: color, strokeWidth: '1.5' }),
            _react2.default.createElement('path', { d: 'M21.265.905L25.82 5.46M21.265.905L25.82 5.46m-4.555 0L25.82.906M21.265 5.46L25.82.906', stroke: color, strokeWidth: '1.5', strokeLinecap: 'round', strokeLinejoin: 'round' }),
            _react2.default.createElement('path', { d: 'M6.232 8.29a.882.882 0 0 1 0-1.27c.35-.35.92-.35 1.27 0s.35.92 0 1.27c-.18.18-.41.27-.64.27-.23 0-.46-.09-.63-.27m2.12 2.13a.9.9 0 0 1 0-1.27.89.89 0 0 1 1.27-.01v.01a.894.894 0 1 1-.63 1.53c-.23 0-.46-.09-.64-.26m10.062-2.11a.911.911 0 0 1 0-1.28c.36-.35.93-.35 1.28 0s.35.93 0 1.28c-.18.17-.41.26-.64.26-.23 0-.46-.09-.64-.26m-2.12 2.12a.911.911 0 0 1 0-1.28c.36-.35.92-.35 1.28 0 .35.36.35.93 0 1.28-.18.17-.41.26-.64.26-.23 0-.46-.09-.64-.26', fill: color })
          )
        )
      );
    }
  }, {
    key: 'onMouseOut',
    value: function onMouseOut() {
      this.setState({ isHovering: false });
    }
  }, {
    key: 'onMouseOver',
    value: function onMouseOver() {
      this.setState({ isHovering: true });
    }
  }]);

  return _class;
}(_react.Component);

_class.propTypes = {
  color: _react.PropTypes.string.isRequired,
  hoverColor: _react.PropTypes.string
};
_class.displayName = 'Track';
exports.default = _class;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../~/@segment/icons/build/react/Track.js
// module id = 1097
// module chunks = 0